import { render } from "./smart-specs.html?vue&type=template&id=46b80dc9&scoped=true&lang=html&external"
import script from "./smart-specs.vue?vue&type=script&lang=js"
export * from "./smart-specs.vue?vue&type=script&lang=js"

import "./_smart-specs.mobile.scss?vue&type=style&index=0&id=46b80dc9&lang=scss&scoped=true&external"
import "./_smart-specs.desktop.scss?vue&type=style&index=1&id=46b80dc9&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b80dc9"]])

export default __exports__